import React from 'react';
import { useIntl } from 'react-intl';
import { StyledSecondaryNavBar, StyledContainer } from '@whitelabel/rentalcover-shared/styled/StyledSecondaryNavBar';
import NavItem from '@whitelabel/rentalcover-shared/components/NavItem';
import { protectionLink, claimsLink, offersLink } from '@whitelabel/rentalcover-shared/helpers/navLinks';
import rentalcoverSharedMessages from '@whitelabel/rentalcover-shared/helpers/messages/commonMsg';
import { ReactComponent as IconArrowLeft } from '@whitelabel/media/icons/small/arrow-left.svg';
import { getButtonProps } from '@whitelabel/rentalcover-shared/helpers/button';
import { useRCOffers } from '../../../../helpers/hooks';

interface ISecondaryNavBarProps {
  claimReference?: string;
}

const SecondaryNavBar = ({ claimReference }: ISecondaryNavBarProps) => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;
  const { showOffers } = useRCOffers();

  return (
    <StyledSecondaryNavBar>
      <StyledContainer>
        {claimReference ? (
          <NavItem
            key="details"
            name={formatMessage(rentalcoverSharedMessages.yourClaimsLinkText)}
            icon={IconArrowLeft}
            {...getButtonProps({ link: `/claims/${claimReference}/details`, locale })}
          />
        ) : (
          <>
            <NavItem {...protectionLink(intl)} {...getButtonProps({ link: protectionLink(intl).path, locale })} />
            <NavItem {...claimsLink(intl)} {...getButtonProps({ link: claimsLink(intl).path, locale })} />
            {showOffers && (
              <NavItem {...offersLink(intl)} {...getButtonProps({ link: offersLink(intl).path, locale })} />
            )}
          </>
        )}
      </StyledContainer>
    </StyledSecondaryNavBar>
  );
};

export default SecondaryNavBar;
